export const ViewMode = {
    view: 'view',
    edit: 'edit',
    create: 'create'
} as const;
